<template>
  <v-dialog v-model="isVisible" max-width="600px" persistent>
    <v-card class="surface">
      <v-card-title class="surface lighten-1 pa-0 pt-4 d-block">
        <div class="d-flex justify-space-between align-center pl-4 pr-2 pb-4">
          <div class="agent-name">
            <strong>{{ agentName }}</strong>
          </div>
          <v-btn icon @click="closePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider />
      </v-card-title>

      <v-divider />

      <v-card-text class="surface">
        <div class="details-content">
          <!-- KPI Summary -->
          <div class="detail-section">
            <div class="kpi-summary d-flex align-center">
              <span class="kpi-label">
                {{ header.text }}
              </span>
              <span class="kpi-value">0</span>
            </div>
          </div>

          <v-divider class="my-4" />

          <!-- Detail Sections - Vertically Stacked -->
          <div class="detail-sections">
            <!-- Business Processes Row -->
            <div class="detail-row-section">
              <v-subheader class="group-subheader pa-0 mt-0">
                <b>Business Processes</b>
              </v-subheader>
              <div class="fields-container">
                <table class="detail-table">
                  <tr>
                    <td class="name">Bp1</td>
                    <td class="value">0</td>
                  </tr>
                  <tr>
                    <td class="name">Bp2</td>
                    <td class="value">3</td>
                  </tr>
                  <tr>
                    <td class="name">Bp3</td>
                    <td class="value">5</td>
                  </tr>
                </table>
              </div>
            </div>

            <!-- Origin Row -->
            <div class="detail-row-section">
              <v-subheader class="group-subheader pa-0 mt-0">
                <b>Origin</b>
              </v-subheader>
              <div class="fields-container">
                <table class="detail-table">
                  <tr>
                    <td class="name">Incoming</td>
                    <td class="value">0</td>
                  </tr>
                  <tr>
                    <td class="name">Outgoing external</td>
                    <td class="value">3</td>
                  </tr>
                  <tr>
                    <td class="name">Callback</td>
                    <td class="value">5</td>
                  </tr>
                </table>
              </div>
            </div>

            <!-- Media Row -->
            <div class="detail-row-section">
              <v-subheader class="group-subheader pa-0 mt-0">
                <b>Media</b>
              </v-subheader>
              <div class="fields-container">
                <table class="detail-table">
                  <tr>
                    <td class="name">Telephony</td>
                    <td class="value">0</td>
                  </tr>
                  <tr>
                    <td class="name">Chat</td>
                    <td class="value">3</td>
                  </tr>
                  <tr>
                    <td class="name">Sms</td>
                    <td class="value">5</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions class="surface lighten-1">
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closePopup">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EcsTableCellDetails',

  props: {
    show: {
      type: Boolean,
      required: true
    },
    header: {
      type: Object,
      required: true
    },
    agentName: {
      type: String,
      required: true
    }
  },

  computed: {
    isVisible: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.closePopup();
        }
      }
    }
  },

  methods: {
    closePopup() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.details-content {
  min-height: 400px;
  padding: 8px 0;
}

.detail-section {
  margin-bottom: 16px;
}

.agent-name {
  font-size: 1.2em;
}

.kpi-summary {
  font-size: 1rem;
  padding-top: 8px;
}

.kpi-label {
  text-transform: uppercase;
  font-weight: bolder;
  color: var(--v-primary-base);
  padding-right: 8px;
}

.kpi-value {
  font-size: 0.875rem;
  font-weight: bolder;
  border: 2px solid #333;
  background: #fff;
  color: #333;
  padding: 8px 16px;
  border-radius: 4px;
  display: inline-block;
  min-width: 60px;
}

.detail-sections {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detail-row-section {
  width: 100%;
}

.detail-row-section .v-subheader {
  text-transform: uppercase;
  font-weight: bolder;
}

.fields-container {
  height: 150px;
  max-height: 150px;
  overflow: auto;
}

.detail-table {
  width: 100%;
  border-collapse: collapse;
}

.detail-table td {
  border: 1px solid #ccc;
  padding: 8px;
  font-size: 0.9em;
}

.detail-table td.name {
  background: #777;
  color: white;
  width: 70%;
  font-weight: 500;
}

.detail-table td.value {
  background: #fff;
  color: #333;
  width: 30%;
  text-align: center;
  font-weight: bold;
}

.group-subheader {
  color: var(--v-primary-base) !important;
}
</style>
